// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 117 ? "628765dd" : chunkId) + "." + {"117":"73dd39ad79b601cb","2078":"2e208a2006e958ee","4555":"34db7ec534645810","6255":"bc78bef7af7b0177"}[chunkId] + ".js";
};